import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phoneFormat',
    standalone: false
})
export class PhoneFormatPipe implements PipeTransform {

    transform(value: string | number): string {
        if (!value) return '';

        // Convert to string and remove non-digit characters
        const digits = value.toString().replace(/\D/g, '');

        // Format only if 10 digits
        if (digits.length !== 10) return value.toString();

        const areaCode = digits.slice(0, 3);
        const firstPart = digits.slice(3, 6);
        const secondPart = digits.slice(6);

        return `(${areaCode}) ${firstPart}-${secondPart}`;
    }
}
